import React from 'react';
import Styled from 'styled';

import ImageView from 'lib/images/responsive-image-view';

import { VendorInformationFragment } from 'four-nets/photoblog/user-blog/author-side/author-side-components/vendor-information/vendor-information.graphql';
import { hideExpiredVendorContent } from 'four-nets/vendor/permissions';

import CoverButtonsUser from './cover-buttons-user/cover-buttons-user';
import CoverButtonsOwner from './cover-buttons-owner/cover-buttons-owner';

import { CoverFragment } from './cover.graphql';
import defaultStyles from './cover.scss';

export interface Props extends CoverFragment {
    styles: typeof defaultStyles;
    tag?: string;
    edit?: boolean;
    writeMail: (to: string) => void;
    isVendor: boolean;
    vendor: VendorInformationFragment;

    buttonsOnly?: boolean;
    imageOnly?: boolean;
}

class Cover extends React.Component<Props> {
    static defaultProps = {
        isVendor: false,
    };

    render() {
        const { styles, vendor, ...rest } = this.props;
        const { user, writeMail, coverImage, edit, buttonsOnly, imageOnly } = rest;

        const buttons = edit ? (
            <CoverButtonsOwner
                buttonsOnly={buttonsOnly}
                username={user!.username}
                hasCoverImage={coverImage && coverImage.id}
                vendor={vendor}
            />
        ) : hideExpiredVendorContent(vendor) ? null : (
            <CoverButtonsUser {...rest} buttonsOnly={buttonsOnly} writeMail={writeMail} />
        );

        if (buttonsOnly) {
            return buttons;
        } else if (imageOnly) {
            return (
                <div className={styles.container}>
                    <ImageView
                        aspectFill={true}
                        alt='coverphoto'
                        noBackground={true}
                        src={(coverImage && coverImage.src) || ''}
                        srcSet={(coverImage && coverImage.srcset) || ''}
                    />
                </div>
            );
        }

        return (
            <div className={styles.container}>
                <ImageView
                    aspectFill={true}
                    alt='coverphoto'
                    noBackground={true}
                    src={(coverImage && coverImage.src) || ''}
                    srcSet={(coverImage && coverImage.srcset) || ''}
                />
                <div className={styles.buttons}>{buttons}</div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Cover);
